module.exports = __webpack_public_path__ + "static/wiseguy-d80fbc37e35ef001095d724123b51314.jpg";